import { useHasPermission } from './useHasPermission';

// 'modify-project-checklists' abilita la modifica delle sole checklist di incarichi/attingimenti, fatture e pagamenti
const PROJECT_CHECKLIST_ENTITY_TYPES = ['contracts', 'invoices', 'invoicepayments'];

// 'modify-checklists' abilita la modifica di tutte le checklist, a prescindere dall'entità
export const useCanEditChecklist = (entityType?: string): boolean => {
	const canModifyAll = useHasPermission('modify-checklists');
	const canModifyProject = useHasPermission('modify-project-checklists');

	return canModifyAll || (canModifyProject && PROJECT_CHECKLIST_ENTITY_TYPES.includes((entityType ?? '').toLowerCase()));
};
